import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import InputField from "../../../components/ui/InputField";
import DashboardTemplate from "../DashboardLayout";
import UploadPlaceholder from "../../../assets/images/image-placeholder.png";

const PersonalInformationForm = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const themeId = searchParams.get("themeId");

  const [formData, setFormData] = useState({
    themeId: themeId || "",
    brideName: "",
    brideFather: "",
    brideMother: "",
    brideIg: "",
    brideOrder: "",
    groomName: "",
    groomFather: "",
    groomMother: "",
    groomIg: "",
    groomOrder: "",
  });

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileUpload = (files) => {
    const validFiles = Array.from(files).filter((file) =>
      ["image/jpeg", "image/png"].includes(file.type)
    );

    if (validFiles.length > 0) {
      setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    }
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles(selectedFiles.filter((_, i) => i !== index));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    handleFileUpload(e.dataTransfer.files);
  };

  return (
    <DashboardTemplate>
      <h1 className="text-2xl font-bold font-montserrat">Silahkan isi data diri anda</h1>

      {/* Mempelai Wanita */}
      <h2 className="text-xl font-semibold font-montserrat mb-4">Mempelai Wanita</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <InputField title="Nama Lengkap" name="brideName" placeholder="Masukkan Nama Lengkap" value={formData.brideName} onChange={handleChange} />
        <InputField title="Putri Ke Berapa" name="brideOrder" placeholder="01" type="number" value={formData.brideOrder} onChange={handleChange} />
        <InputField title="Nama Ayah" name="brideFather" placeholder="Misal John" value={formData.brideFather} onChange={handleChange} />
        <InputField title="Nama Ibu" name="brideMother" placeholder="Misal Eve" value={formData.brideMother} onChange={handleChange} />
        <InputField title="Username IG" name="brideIg" placeholder="Misal @John" value={formData.brideIg} onChange={handleChange} />
      </div>

      {/* Mempelai Pria */}
      <h2 className="text-xl font-semibold font-montserrat mb-4">Mempelai Pria</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField title="Nama Lengkap" name="groomName" placeholder="Masukkan Nama Lengkap" value={formData.groomName} onChange={handleChange} />
        <InputField title="Putra Ke Berapa" name="groomOrder" placeholder="01" type="number" value={formData.groomOrder} onChange={handleChange} />
        <InputField title="Nama Ayah" name="groomFather" placeholder="Misal Agus" value={formData.groomFather} onChange={handleChange} />
        <InputField title="Nama Ibu" name="groomMother" placeholder="Misal Ayu" value={formData.groomMother} onChange={handleChange} />
        <InputField title="Username IG" name="groomIg" placeholder="Misal @John" value={formData.groomIg} onChange={handleChange} />
      </div>

      {/* Upload Foto */}
      <h2 className="text-xl font-semibold font-montserrat mt-6 text-center">
        Unggah Foto Prewedding
      </h2>
      <div className="flex flex-col items-center mt-4">
        <div
          className={`border-2 max-w-lg w-full p-10 rounded-xl flex flex-col items-center justify-center transition-all duration-200 ${
            isDragging ? "border-blue-500 bg-blue-100" : "border-gray-400 border-dashed"
          }`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <label htmlFor="file-upload" className="cursor-pointer flex flex-col items-center">
            <img src={UploadPlaceholder} alt="Upload" className="w-16 h-16 mb-2" />
            <p className="text-gray-600 text-center">
              {isDragging ? "Lepaskan file di sini..." : "Drop file(s) here, or"}
              <span className="text-blue-500"> Browse</span>
            </p>
            <p className="text-gray-400 text-sm">Supports: JPG, PNG, Max file size 10 MB</p>
          </label>
          <input
            id="file-upload"
            type="file"
            className="hidden"
            multiple
            accept="image/jpeg, image/png"
            onChange={(e) => handleFileUpload(e.target.files)}
          />
        </div>

        {/* List File yang Diunggah */}
        {selectedFiles.length > 0 && (
          <div className="mt-6 w-full max-w-lg">
            {selectedFiles.map((file, index) => (
              <div key={index} className="flex items-center bg-gray-100 rounded-md p-2 mb-2 shadow">
                <div className="flex-1">
                  <p className="text-gray-800 text-sm">{file.name}</p>
                  <div className="w-full h-1 bg-gray-300 rounded-full mt-1">
                    <div className="h-1 bg-red-400 w-1/3 rounded-full"></div>
                  </div>
                </div>
                <button className="text-red-500 ml-2" onClick={() => handleRemoveFile(index)}>
                  ✖
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </DashboardTemplate>
  );
};

export default PersonalInformationForm;
